export default "__VITE_ASSET__d48bc209__"